import React from 'react';
import type { Props as SelectProps } from 'react-select';

const CustomNoOptionsMessage: React.FC<SelectProps & { message: string }> = ({
  message,
  ...props
}) => {
  const {
    innerProps: { ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} className={'text-center text-muted font-normal italic my-sm'}>
      {message}
    </div>
  );
};

export default CustomNoOptionsMessage;
